import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import Collections from "../../../../../components/Collections";

const breadcrumbsStatic = [
	{
		name:'Financials',
		url: '/financial',
		icon:'dashboard'
	},
	{
	name: 'WorkOrders',
	url: '/financial/work_orders',
	icon: 'book',
}];

class WorkOrders extends Framework.Components.View {
	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}/>
				<Collections.WorkOrders />
			</div>
		)
	}
}

export default Framework.Components.withRootState(WorkOrders);